<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="编号" prop="id">
                <a-input v-model="queryParam.id" placeholder="请输入编号" @pressEnter="handleQuery" allow-clear />
              </a-form-item>
            </a-col> -->
            <a-col :md="8" :sm="24">
                  <a-form-item label="类型" prop="type">
                    <a-select v-model="queryParam.type" allow-clear >
                      <a-select-option :value="1">早餐</a-select-option>
                      <a-select-option :value="2">午餐</a-select-option>
                      <a-select-option :value="3">晚餐</a-select-option>
                      <a-select-option :value="4">加餐</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
            <!-- <a-col :md="8" :sm="24">
                <a-form-item label="课程姓名" prop="courseName">
                  <a-input v-model="queryParam.courseName" placeholder="请输入课程姓名" @pressEnter="handleQuery" allow-clear />
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="购买人名称" prop="nickname">
                    <a-input v-model="queryParam.nickname" placeholder="请输入购买人名称" @pressEnter="handleQuery" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="购买人手机号" prop="mobile">
                    <a-input v-model="queryParam.mobile" placeholder="购买人手机号" @pressEnter="handleQuery" allow-clear />
                  </a-form-item>
                </a-col>

                <a-col :md="8" :sm="24">
                  <a-form-item label="订单状态" prop="status">
                    <a-select v-model="queryParam.status">
                      <a-select-option :value="-1">已取消</a-select-option>
                      <a-select-option :value="0">待支付</a-select-option>
                      <a-select-option :value="1">已支付</a-select-option>
                      <a-select-option :value="2">已发货</a-select-option>
                      <a-select-option :value="3">已完成</a-select-option>
                      <a-select-option :value="4">售后中</a-select-option>
                      <a-select-option :value="5">待评价</a-select-option>
                      <a-select-option :value="6">已收货</a-select-option>
                      <a-select-option :value="7">售后完成</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="时间">
                <a-range-picker
                  style="width: 100%"
                  v-model="queryParam.dateRange"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  allow-clear
                />
              </a-form-item>
            </a-col> -->
            <!-- </template> -->
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- <create-form ref="createForm" @ok="getList" /> -->
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :scroll="{ x: 1500, y: 'calc(100vh - 400px)' }"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (current - 1) * size + index + 1 }}
        </span>

        <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.image"
            :src="record.image"
            preview="头像"
          />
        </span>
        <span slot="operation" slot-scope="text, record">
          <!--          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />-->
          <a @click="$refs.OrderCreateForm.handleUpdate(record, undefined)" v-hasPermi="['order:order:edit']">
            <a-icon type="file" />查看详情
          </a>
          <!--          <a-divider type="vertical" v-hasPermi="['order:order:remove']" />-->
          <!--          <a @click="handleDelete(record)" v-hasPermi="['order:order:remove']">-->
          <!--            <a-icon type="delete" />删除-->
          <!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
// import { pageOrderOrder, listOrderOrder, delOrderOrder } from '@/api/order/orderOrder'
import OrderCreateForm from './modules/OrderCreateForm'
import { pageEatingRecord } from '@/api/user/report'

import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'diet',
  components: {
    OrderCreateForm,
  },
  props: ['type'],
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        // 时间访问查询
        // dateRange: [],
        createBeginTime: '',
        createEndTime: '',
        date: '',
        foodId: null,
        month: '', //yyyy-MM
        sortField: '',
        sortOrder: '',
        type: null, //1-早餐 2-午餐 3-晚餐 4-加餐
        userId: null,
        logisticsCompany: null,
        logisticsNumber: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: {
            customRender: 'index',
          },
        },
        {
          title: '食物名称',
          dataIndex: 'foodName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '食物图片',
          dataIndex: 'image',
          scopedSlots: { customRender: 'image' },
          align: 'center',
          width: 100,
        },
        {
          title: '碳水化合物热量',
          dataIndex: 'carbohydrateQK',
          width:180,
          align: 'center'
        },
        {
          title: '碳水化合物份量',
          dataIndex: 'carbohydrateWeight',
          align: 'center',
          width:180
        },
        {
          title: '脂肪热量',
          dataIndex: 'fatQK',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '脂肪份量',
          dataIndex: 'fatWeight',
          ellipsis: true,
          width: 180,
          align: 'center',
        },


        {
          title: '食物类型',
          dataIndex: 'foodType',
          customRender:function (e) {
            if(e === '1'){
              return "红灯";
            }else if(e === '2') {
              return "黄灯";
            } else {
              return "红灯";
            }
          }
        },
        {
          title: '食物份量',
          dataIndex: 'foodWeight',
          ellipsis: true,
          align: 'center'
        },

        {
          title: '千卡',
          dataIndex: 'kilocalorie',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '蛋白质热量',
          dataIndex: 'proteinQK',

          ellipsis: true,
          align: 'center',
          width: 180,
        },
        {
          title: '蛋白质份量',
          dataIndex: 'proteinWeight',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '类型',
          dataIndex: 'type',
          customRender:function (e) {
            if(e === '1'){
              return "早餐";
            }else if(e === '2') {
              return "午餐";
            } else if(e === '3') {
              return "晚餐";
            } else {
              return "加餐";
            }
          }
        },
        {
          title: '单位',
          dataIndex: 'weightUnit',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ],
    }
  },
  filters: {},
  mounted() {
    if (this.type != 'tk') {
      this.getList()
    }
  },
  computed: {},
  watch: {},
  methods: {
    goList(record, type) {
      var this_ = this
      this_.$nextTick(() => {
        this_.queryParam.userId = record.id
        // this_.queryParam.type = type
        this_.list = []
        this_.total = 0
        this_.current = 0
        this_.size = 0
        this_.getList() //这是我自定义的
      })
    },
    /** 查询订单信息列表 */
    getList() {
      this.loading = true
      // if(this.dateRange.length>0) {
      //   this.queryParam.createBeginTime = this.dateRange[0] +" 00:00:00"
      //   this.queryParam.createEndTime = this.dateRange[1]+" 23:59:59"
      // }else {
      //   this.queryParam.createBeginTime = null
      //   this.queryParam.createEndTime = null
      // }
      pageEatingRecord(this.queryParam).then((response) => {
        this.loading = false
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size

      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParam.pageNum = 1
      // this.queryParam.type = 4
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        createBeginTime: '',
        createEndTime: '',
        date: '',
        foodId: null,
        month: '', //yyyy-MM
        sortField: '',
        sortOrder: '',
        type: null, //1-早餐 2-午餐 3-晚餐 4-加餐
        logisticsCompany: null,
        logisticsNumber: null,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) =>
            data.push({
              id: id,
            })
          )
          return delOrderOrder(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'order/order/export',
            {
              ...that.queryParam,
            },
            `订单信息_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
